class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
  }

  connectedCallback() {
    this.performRecommendations();
  }

  performRecommendations() {
    const recommendations = this.querySelector(
      '[data-recommendations]'
    );
    if (!recommendations) return;
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const recommendationsFromResponse = parsed.querySelector(
          '[data-recommendations]'
        );
        if (!recommendationsFromResponse) return;
        const recommendationsHMTL = recommendationsFromResponse.innerHTML;
        if (!recommendationsHMTL) return;
        this.classList.remove('hidden');
        recommendations.innerHTML = recommendationsHMTL;
        this.initSlider();
      });
  }

  initSlider() {
    // Create unique IDs for this carousel instance
    const carouselId = `carousel-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    this.setAttribute('data-carousel-id', carouselId);
    
    // Find navigation buttons - try multiple approaches
    let nextBtn = this.querySelector('.swiper-button--next');
    let prevBtn = this.querySelector('.swiper-button--prev');
    
    // If not found inside, try parent section
    if (!nextBtn || !prevBtn) {
      const section = this.closest('section') || this.closest('[data-section-id]');
      if (section) {
        nextBtn = nextBtn || section.querySelector('.swiper-button--next');
        prevBtn = prevBtn || section.querySelector('.swiper-button--prev');
      }
    }
    
    // Only assign to this carousel if buttons are not already assigned to another carousel
    if (nextBtn && !nextBtn.hasAttribute('data-carousel-id')) {
      nextBtn.setAttribute('data-carousel-id', carouselId);
      nextBtn.id = `next-${carouselId}`;
    }
    if (prevBtn && !prevBtn.hasAttribute('data-carousel-id')) {
      prevBtn.setAttribute('data-carousel-id', carouselId);
      prevBtn.id = `prev-${carouselId}`;
    }

    this.slider = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 'auto',
      spaceBetween: 8,
      navigation: {
        nextEl: (nextBtn && nextBtn.getAttribute('data-carousel-id') === carouselId) ? `#next-${carouselId}` : null,
        prevEl: (prevBtn && prevBtn.getAttribute('data-carousel-id') === carouselId) ? `#prev-${carouselId}` : null
      }
    });
  }
}

customElements.define('cart-recommendations', CartRecommendations);
